var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { html } from 'lit';
import { SgdfElement } from '../../internal/sgdf-element.js';
import styles from './function-badge.styles.js';
import { FunctionColor } from '../../themes/theme';
import '../../atoms/badge/badge.js';
const getFormattedFonction = (branche) => {
    if (branche == "210") {
        return 'L/J';
    }
    if (branche == '220') {
        return 'S/G';
    }
    if (branche == '230') {
        return 'P/C';
    }
    if (branche == '240') {
        return 'COMPA';
    }
    if (branche == '270') {
        return 'FARFA';
    }
    if (branche == '290') {
        return 'AUDACE';
    }
    if (branche == '180') {
        return 'IMPEESA';
    }
    if (branche == '310') {
        return 'GROUPE';
    }
    if (branche == '300') {
        return 'RG';
    }
    if (branche == '600') {
        return 'TERR';
    }
    if (branche == '505') {
        return 'RTERR';
    }
    if (branche == '500') {
        return 'DT';
    }
    if (branche == '900') {
        return 'NATIONAL';
    }
    if (branche == '980') {
        return 'SALARIE';
    }
    return 'AUTRE';
};
const colorByCode = {
    'L/J': FunctionColor.LJ,
    'S/G': FunctionColor.SG,
    'P/C': FunctionColor.PC,
    'COMPA': FunctionColor.Compa,
    'FARFA': FunctionColor.Farf,
    'AUDACE': FunctionColor.Audace,
    'GROUPE': FunctionColor.Groupe,
    'IMPEESA': FunctionColor.Impeesa,
    'RG': FunctionColor.Groupe,
    'TERR': FunctionColor.Territoire,
    'RTERR': FunctionColor.Territoire,
    'DT': FunctionColor.Territoire,
    'NATIONAL': FunctionColor.National,
    'SALARIE': FunctionColor.Salarie,
    AUTRE: FunctionColor.Autre,
};
/**
 * @summary Badge by function code.
 * @status stable
 * @since 1.0
 *
 * @dependency sgdf-badge
 *
 */
class SgdfFunctionBadge extends SgdfElement {
    constructor() {
        super(...arguments);
        this.branche = '0';
    }
    render() {
        const formattedFonction = getFormattedFonction(this.branche);
        return html ` <sgdf-badge color=${colorByCode[formattedFonction]}
            >${formattedFonction}</sgdf-badge
        >`;
    }
}
SgdfFunctionBadge.styles = styles;
export default SgdfFunctionBadge;
__decorate([
    property({ type: String, reflect: true })
], SgdfFunctionBadge.prototype, "branche", void 0);
//# sourceMappingURL=function-badge.component.js.map